export default defineNuxtRouteMiddleware((to, from) => {
    if (process.client) {
        const clinicRef = to.query.clinic_ref
        if (clinicRef) {
            localStorage.setItem('clinic_ref', clinicRef as string)
            localStorage.removeItem(DOCTOR_REF_STORAGE_KEY)

            const newQuery = { ...to.query }
            delete newQuery.clinic_ref

            // Делаем редирект на тот же путь, но без параметра
            return navigateTo({
                path: to.path,
                query: newQuery
            }, { redirectCode: 302 })
        }
    }
});